import { render, staticRenderFns } from "./certificateCourse.vue?vue&type=template&id=23fda392"
import script from "./certificateCourse.vue?vue&type=script&lang=js"
export * from "./certificateCourse.vue?vue&type=script&lang=js"
import style0 from "./certificateCourse.vue?vue&type=style&index=0&id=23fda392&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports